import React, { Component } from "react";
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import "./../../View.css";
import "./../../Grid.css";
import "./../../Form.css";
import EnhancedToolbar from '../../widgets/Toolbar';
import AlertItem from "../../widgets/AlertItem";
import "./../../App.css";
import { ViewContainer } from "./../../View.jsx";
import EnhancedTable from '../../widgets/ResponsiveTable';
import ViewUtils from '../../ViewUtils';
import { AssessmentHeaderForm } from './AssessmentHeaderForm';

const headCells = [
    { id: 'ProgrammeCode', numeric: false, disablePadding: true, label: 'Sub Module Code' },
    { id: "ProgrammeTitle", numeric: false, disablePadding: true, label: "Sub Module Title" },
    { id: "Credits", numeric: false, disablePadding: true, label: "Credits" },
    { id: "RPL", numeric: false, disablePadding: true, label: "RPL" },
    { id: "Assessor", numeric: false, disablePadding: true, label: "Assessor" },
    { id: "AssessmentDate", numeric: false, disablePadding: true, label: "Assessment Date" },
    { id: "Moderator", numeric: false, disablePadding: true, label: "Moderator" },
    { id: "ModerationDate", numeric: false, disablePadding: true, label: "Moderation Date" },
    { id: "Status", numeric: false, disablePadding: true, label: "Status" },
]


const utils = new ViewUtils();
const toolbarRef = React.createRef();
const learnerRef = React.createRef();

class ViewQCTOQualificationSubModuleAssessment extends Component {

    constructor(props) {
        super(props)
        this.state = {
            model: {
                AssessmentID: null
            },
            selectedUnitStandards: null,
            keyUpSwitch: false,
            updateUSd: false,
            messsageAlert: null,
            messageStyle: null,
            showTable: true,
            searchParameters: [
                { Name: "AssessmentID", Value: this.props.location.state.QualificationID },
                { Name: "ModuleID", Value: this.props.location.state.ModuleID }
            ]
        }

        this.toolbarConfig = {
            items: [
                {
                    type: "buttonGroup",
                    buttons: [
                        { id: 'cancel', label: 'CLOSE', tooltip: 'Close', icon: 'CloseIcon', icon: 'CloseIcon' }
                    ]
                },
                {
                    type: "devider"
                },
                {
                    type: "buttonGroup",
                    buttons: [
                        { id: 'updateUS', label: '', tooltip: 'UPDATE SUB MODULE', icon: 'UpdateIcon', visible: this.props.location.state.permissions.Edit },
                        { id: 'remove', label: '', tooltip: 'REMOVE SELECTED ASSESSMENTS', icon: "DeleteIcon", visible: this.props.location.state.permissions.Delete }
                    ]
                }
            ]
        };
    }

    handleToolbarButtonClick = (buttonId) => {
        if ("updateUS" === buttonId) {
            this.updateUSDocuments();
        }
        else if ("cancel" === buttonId) {
            this.props.history.push({
                pathname: '/ViewQCTOQualificationAssessment',
                state: {
                    LearnerID: this.props.location.state.LearnerID,
                    learnerNames: this.props.location.state.learnerNames,
                    QualificationID: this.props.location.state.QualificationID,
                    permissions: this.props.location.state.permissions
                }
            });
        } else if ("remove" === buttonId) {
            this.removeAssessments();

        }
    }

    handleToolbarButtonClickClose = (buttonId) => {
        if ("cancel" === buttonId) {

        }
    }

    removeAssessments() {
        const UnitStandardIDs = this.state.selectedUnitStandards.map(e => e.Id);
        let data = {
            UnitStandardIDs: UnitStandardIDs,
            ...this.state.model
        }
        let input = JSON.stringify(data);
        utils.invokeUrl("api/sims/LearnerQCTOQualificationAssessment/RemoveLearnerQCTOQualificationSubModuleAssessment", this.successCallback, () => { alert(utils.SYSTEM_ERROR_MESSAGE) }, {
            method: 'PUT',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                "Authorization": "Bearer " + localStorage.getItem("token")
            },
            body: input
        });
    }

    successCallback = (response) => {
        this.setState({
            showTable: false,
            message: response.Message, messageStyle: response.MessageType
        }, () => {
            this.setState({ showTable: true, message: response.Message, messageStyle: response.MessageType })
        });
    }

    updateUSDocuments() {
        const UnitStandardIDs = this.state.selectedUnitStandards.map(e => e.Id);
        let data = {
            UnitStandardIDs: UnitStandardIDs,
            ...this.state.model
        }
        let input = JSON.stringify(data);
        utils.invokeUrl("api/sims/LearnerQCTOQualificationAssessment/UpdateLearnerQCTOQualificationSubModuleAssessment", (response) => {
            this.successCallback(response);
        }, () => { alert(utils.SYSTEM_ERROR_MESSAGE) }, {
            method: 'PUT',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                "Authorization": "Bearer " + localStorage.getItem("token")
            },
            body: input
        });
    }

    handleSelectionChange = (selection) => {
        if (selection !== null && selection.length !== 0) {
            this.setState({ selectedUnitStandards: selection, Message: "" },
                () => {
                    toolbarRef.current.setButtonDisabled("updateUS", selection.length === 0);
                    toolbarRef.current.setButtonDisabled("remove", selection.length === 0);
                }
            )
        } else {
            this.setState({ selectedUnitStandards: null, Message: "" },
                () => {
                    toolbarRef.current.setButtonDisabled("updateUS", selection.length === 0);
                    toolbarRef.current.setButtonDisabled("remove", selection.length === 0);
                }
            )
        }
    }

    handleFormValueChange = (values) => {
        let newValues = null;
        if (!utils.isNull(values)) {
            newValues = { ...values };
        }
        if (!utils.isNull(newValues)) {
            if (JSON.stringify(this.state.model) !== JSON.stringify(newValues)) {
                this.setState({
                    model: newValues,
                    Message: ""
                });
                toolbarRef.current.setButtonDisabled("updateUS", true);
                toolbarRef.current.setButtonDisabled("Cancel", true);
                toolbarRef.current.setButtonDisabled("remove", true);
            }
        }
    }

    render() {
        return (
            <ViewContainer mode={this.props.mode} title="">
                <p className="breadcrumbs">
                    {`Learner > Update QCTO Qualification Sub Module Assessment > ${this.props.location.state.learnerNames}`}
                </p>
                <AlertItem message={this.state.message} alertStyle={this.state.messageStyle} />
                {this.props.location.state.permissions.Edit === true && this.state.showTable === true && (
                    <AssessmentHeaderForm
                        ref={learnerRef}
                        viewRef={this}
                        id={this.props.location.state.QualificationID}
                        valueChangeHandler={(values) => this.handleFormValueChange(values)}
                        controllerName={"LearnerQCTOQualificationAssessment"}
                        dataURL='api/sims/LearnerQCTOQualificationAssessment/GetLearnerQCTOQualificationAssessmentHeaderDetails' />
                )}
                <td>
                    <EnhancedToolbar
                        ref={toolbarRef}
                        highlight={false}
                        buttonClickHandler={(buttonId) => this.handleToolbarButtonClick(buttonId)}
                        config={this.toolbarConfig} />
                </td>
                <div>
                    Module: {this.props.location.state.ModuleCode + ' - ' + this.props.location.state.ModuleTitle}
                </div>
                <div>
                    {this.props.location.state.permissions.Edit === true && this.state.showTable === true && (
                        <EnhancedTable
                            multiSelect={true}
                            headCells={headCells}
                            dataUrl="api/sims/LearnerQCTOQualificationAssessment/getLearnerQCTOQualificationSubModuleAssessmentDetails"
                            onSelectionChange={(selection) => { this.handleSelectionChange(selection) }}
                            searchParameters={this.state.searchParameters} paged={true} />
                    )}
                    {this.props.location.state.permissions.Edit === false && this.state.showTable === true && (
                        <EnhancedTable
                            headCells={headCells}
                            dataUrl="api/sims/LearnerQCTOQualificationAssessment/getLearnerQCTOQualificationSubModuleAssessmentDetails"
                            onSelectionChange={(selection) => { this.handleSelectionChange(selection) }}
                            searchParameters={this.state.searchParameters} paged={true} />
                    )}
                </div>
            </ViewContainer>
        );
    }
}

export default withRouter(
    connect()(ViewQCTOQualificationSubModuleAssessment)
);